import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Twitter, Facebook, Instagram, Linkedin, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-orange-400 to-rose-500 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-bold text-white text-lg">MyBusinessAdPro</span>
          </Link>
          <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
            AI-powered social media ads built for UK small businesses. Stop overpaying agencies. Get scroll-stopping campaigns in seconds.
          </p>
          <div className="mt-5 space-y-1.5 text-sm text-slate-400">
            <a href="mailto:contact@mybusinessadpro.co.uk" className="flex items-center gap-2 hover:text-white transition-colors">
              <Mail className="w-4 h-4 text-orange-400" />
              contact@mybusinessadpro.co.uk
            </a>
            <div className="flex items-start gap-2" data-testid="footer-registered-address">
              <MapPin className="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0" />
              <div className="leading-relaxed">
                <div className="font-medium text-slate-300">KRINAL AHIR LIMITED</div>
                <div>The Spinney, 12 Scothern Lane,</div>
                <div>Sudbrooke, United Kingdom, LN2 2QT</div>
                <div className="text-xs text-slate-500 mt-0.5">Co. No. 11940942 · England &amp; Wales</div>
              </div>
            </div>
          </div>
          <div className="flex gap-3 mt-5">
            {[Twitter, Facebook, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-slate-700 flex items-center justify-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#features" className="hover:text-white transition-colors">Features</a></li>
            <li><a href="#pricing" className="hover:text-white transition-colors">Pricing</a></li>
            <li><a href="#how" className="hover:text-white transition-colors">How it Works</a></li>
            <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/legal" className="hover:text-white transition-colors">Legal &amp; policies</Link></li>
            <li>
              <a
                href="https://find-and-update.company-information.service.gov.uk/company/11940942"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
                data-testid="footer-companies-house"
              >
                Companies House (11940942)
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal" data-testid="footer-legal-index" className="hover:text-white transition-colors">All Legal Documents</Link></li>
            <li><Link to="/legal/terms" data-testid="footer-terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
            <li><Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/legal/trial-terms" data-testid="footer-trial" className="hover:text-white transition-colors">Free Trial Terms</Link></li>
            <li><Link to="/legal/service-agreement" data-testid="footer-service-agreement" className="hover:text-white transition-colors">Service Agreement</Link></li>
            <li><Link to="/legal/cookies" data-testid="footer-cookies" className="hover:text-white transition-colors">Cookie Policy</Link></li>
            <li><Link to="/legal/acceptable-use" data-testid="footer-aup" className="hover:text-white transition-colors">Acceptable Use</Link></li>
            <li><Link to="/legal/refund" data-testid="footer-refund" className="hover:text-white transition-colors">Refund Policy</Link></li>
            <li><Link to="/legal/dpa" data-testid="footer-dpa" className="hover:text-white transition-colors">Data Processing Agreement</Link></li>
            <li><Link to="/legal/asa" data-testid="footer-asa" className="hover:text-white transition-colors">UK ASA Compliance</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500 gap-2">
          <div data-testid="footer-legal-block">
            © {new Date().getFullYear()} <strong className="text-slate-300">KRINAL AHIR LIMITED</strong> (Company No. <strong className="text-slate-300">11940942</strong>), trading as MyBusinessAdPro.
            Registered office: <strong className="text-slate-300">The Spinney, 12 Scothern Lane, Sudbrooke, United Kingdom, LN2 2QT</strong>.
            Contact: <a href="mailto:contact@mybusinessadpro.co.uk" className="text-slate-300 hover:text-white">contact@mybusinessadpro.co.uk</a>
          </div>
          <div>All ads checked against UK ASA standards.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
